<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :manual-check-groups="manualCheckGroups"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/OrderSettings/ManualChecks/Checks/Form'

export default {
    name: 'OrderManualCheckSettingsCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        manualCheckGroups: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.order-manual-check-settings.store'))
        }
    }
}
</script>
